import { ContractCgrpOff } from '@core/models/contract-cgrp-off.model';
import { ContractInformations } from '@core/models/contract-informations.model';
import { ContractNatioNego } from '@core/models/contract-natio-nego.model';
import { ContractOtherCentralAgency } from '@core/models/contract-other-agency.model';
import { ContractThemaNego } from '@core/models/contract-thema-nego.model';
import { ContractUser } from '@core/models/contract-user.model';
import { ContractCommitment } from './contract-commitment.model';

export interface JsonContractItem {
  id: number;
  advertiserId: string;
  year: string;
  natioNegotiationList?: ContractNatioNego[];
  cgrpOffNegotiationList?: ContractCgrpOff[];
  sport?: number;
  majoration?: number;
  f2_13_21?: number;
  f2_19_51?: number;
  f5_19_41?: number;
  f5_19_51?: number;
  projectedRate?: number;
  themaNegotiationList?: ContractThemaNego[];
  commitmentList?: ContractCommitment[];
  contractInformations?: ContractInformations;
  contractUserList?: ContractUser[];
  contractOtherCentralAgencyList?: ContractOtherCentralAgency[];
}

export class ContractItem {
  id: number;
  advertiserId: string;
  year: string;
  natioNegotiationList?: ContractNatioNego[];
  cgrpOffNegotiationList?: ContractCgrpOff[];
  sport?: number;
  majoration?: number;
  f2_13_21?: number;
  f2_19_51?: number;
  f5_19_41?: number;
  f5_19_51?: number;
  projectedRate?: number;
  themaNegotiationList: ContractThemaNego[][] = [];
  commitmentList?: ContractCommitment[];
  contractInformations?: ContractInformations;
  contractUserList?: ContractUser[];
  contractOtherCentralAgencyList?: ContractOtherCentralAgency[];

  constructor(jsonContractItem: JsonContractItem = null) {
    this.id = jsonContractItem.id;
    this.advertiserId = jsonContractItem.advertiserId;
    this.year = jsonContractItem.year;
    this.natioNegotiationList = jsonContractItem.natioNegotiationList;
    this.cgrpOffNegotiationList = jsonContractItem.cgrpOffNegotiationList;
    this.sport = jsonContractItem.sport;
    this.majoration = jsonContractItem.majoration;
    this.f2_13_21 = jsonContractItem.f2_13_21;
    this.f2_19_51 = jsonContractItem.f2_19_51;
    this.f5_19_41 = jsonContractItem.f5_19_41;
    this.f5_19_51 = jsonContractItem.f5_19_51;
    this.projectedRate = jsonContractItem.projectedRate;
    this.themaNegotiationList = this.parseThemaNegotiationList(jsonContractItem.themaNegotiationList);
    this.commitmentList = jsonContractItem.commitmentList;
    this.contractInformations = new ContractInformations(jsonContractItem.contractInformations);
    this.contractUserList = jsonContractItem.contractUserList;
    this.contractOtherCentralAgencyList = jsonContractItem.contractOtherCentralAgencyList;
  }

  private parseThemaNegotiationList(jsonThemaNegotiationList) {
    let guaranteedThemaNegotiationList: ContractThemaNego[] = [];
    let notGuaranteedThemaNegotiationList: ContractThemaNego[] = [];

    jsonThemaNegotiationList?.forEach(negotiation => {
      if (negotiation.isGuaranteed) {
        guaranteedThemaNegotiationList.push(negotiation);
      } else {
        notGuaranteedThemaNegotiationList.push(negotiation);
      }
    });

    return [guaranteedThemaNegotiationList, notGuaranteedThemaNegotiationList];
  }
}
